import { autoinject } from 'aurelia-framework';
import { DialogController, DialogService } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { SecurityService } from '../../services/security-service';
import 'jquery';
import 'notify';
import * as moment from 'moment';
import { BusyService } from '../../services/busy-service';
import { RequestDto } from '../../data/typegen/dtos/request-dto';
import { CarrierStatus } from '../carrier-status-history';
import { PromptDialog } from '../../resources/dialogs/prompt-dialog';
import { SimpleDialog } from './simple-dialog';

@autoinject
export class CarrierOnboardingStatusSummaryDialog {
    public requestNumber: string;
    requestId: string;
    constructor(
        protected controller: DialogController,
        private securityService: SecurityService,
        private busyService: BusyService,
        private api: WebApiService,
        private dialog: DialogService
    ) { }

    missingDocuments = [];
    carrierId: number;

    activate(params) {
        this.carrierId = params.carrierId;
        this.loadCarrierRequirements();
    }

    private loadCarrierRequirements() {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierCurrentRequirements", { carrierId: this.carrierId })
            .then((result) => {
                var reqs = JSON.parse(result.response);
                this.missingDocuments = reqs.filter(o=>o.requirementType==1)
            })
            .finally(() => this.busyService.off());
    }



}